export default __webpack_public_path__ + "static/media/Snd_o3.23bcbef1.mp3";